module.exports = __webpack_public_path__ + "static/media/chevron-left.35341b71.svg";